import React, { Fragment, useState, FC } from 'react'
import PlaylistTrack from '../pages/playlist/PlaylistTrack'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { firestore, storage } from '../../firebase'
import UserLink from '../../utils/UserLink'
import { RootState } from '../../store/reducers'
import { Track } from '../../models/track'

const QueView: FC<{
  que: Track[]
  current: Track
}> = ({ que, current }) => {
  const { username, covername, uid, id } = current
  const [showCurrent, toggle] = useState(true)
  const [mounted, setMounted] = useState(true)
  const [cover, setCover] = useState('')
  const [likes, setLikes] = useState([])
  const [plays, setPlays] = useState([])

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 768) {
      toggle(true)
    }
  })

  useEffect(() => {
    setMounted(true)
    if (covername) {
      storage
        .ref(`covers/${uid}${covername}`)
        .getDownloadURL()
        .then((url) => {
          if (mounted) {
            setCover(url)
          }
        })
    } else {
      if (mounted) {
        setCover('')
      }
    }

    if (current.src) {
      firestore
        .collection('songs')
        .doc(id)
        .onSnapshot((snap) => {
          if (snap.exists) {
            if (mounted) {
              setLikes(snap.data()?.likes)
              setPlays(snap.data()?.plays)
            }
          }
        })
    }

    return () => {
      setMounted(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <div id="que-view" uk-offcanvas="flip: true; overlay: true">
      <div className="uk-offcanvas-bar">
        <span id="que-head">
          <span className="uk-offcanvas-close" data-uk-close></span>
          <h4>Queued songs</h4>
        </span>

        <span id="que-body">
          {que && (
            <div className="que-view-container">
              {!que.length && <h4>You have no songs in que</h4>}
              <div className="que-list">
                {que.map((track, i) => (
                  <PlaylistTrack track={track} key={i} />
                ))}
              </div>

              <div className="que-current">
                {Object.keys(current).length > 1 && (
                  <Fragment>
                    {showCurrent && (
                      <Fragment>
                        <span
                          onClick={() => {
                            if (mounted) toggle(!showCurrent)
                          }}
                          className="close "
                        ></span>
                        <div
                          className="que-cover-art"
                          style={{
                            background: cover
                              ? `url(${cover}) `
                              : 'var(--theme-color)',
                            backgroundSize: 'contain',
                          }}
                        ></div>
                        <div className="que-track-details uk-margin-small-top">
                          <UserLink params={{ username }}>{username}</UserLink>
                          <div>
                            <span>
                              {likes.length}
                              {likes.length === 1 ? `like` : `likes`}
                            </span>
                            <span
                              style={{ fontWeight: 'bolder', fontSize: '18px' }}
                            >
                              .
                            </span>
                            <span>
                              {plays.length}
                              {plays.length === 1 ? `play` : `plays`}
                            </span>
                          </div>
                        </div>
                      </Fragment>
                    )}
                  </Fragment>
                )}
              </div>
            </div>
          )}
        </span>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    que: state.songs.que,
    current: state.songs.current,
  }
}
export default connect(mapStateToProps)(QueView)
